export default {
    optionsContainer: {
        marginTop: "40px",
        display: "flex",
        flexDirection: "column",
        rowGap: "30px",
    },

    optionLabel: {
        margin: "0px",
        fontSize: "20px",
        color: "#262626",
    },

    optionCard: {
        flexDirection: "row",
        justifyContent: "space-between",
        cursor: "pointer"
    },

    circularCheckbox: {
        position: "initital"
    }
}